import CryptoJS from "crypto-js";
import { ivs_key , secret_key } from "../config";

export const AesDecryptlive = (data) => { 
 
    const key = CryptoJS.enc.Hex.parse('0123456789abcdef0123456789abcdef'); // 128-bit key
    const iv = CryptoJS.enc.Hex.parse('abcdef9876543210abcdef9876543210'); // 128-bit IV

    // Decrypt the data using AES-CBC
    const bytes = CryptoJS.AES.decrypt( data , key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedData = bytes.toString(CryptoJS.enc.Utf8)
    return decryptedData
}